import React from "react";
import { ToastContainer, toast } from "react-toastify";
import { IconAlertError, IconAlertInformational, IconAlertSuccess } from "../../utils/icons";
import "react-toastify/dist/ReactToastify.css";
import "./UseAlert.css";

const showAlert = (type, msg, subMsg = "", duration = 2000) => {
  const content = (
    <div className="toast-content">
      <div>{msg}</div>
      {subMsg && <div className="toast-subtext">{subMsg}</div>}
    </div>
  );

  const options = {
    icon: type === "success" ? <IconAlertSuccess /> : type === "info" ? <IconAlertInformational /> : <IconAlertError />,
    autoClose: duration,
  };

  if (type === "success") {
    toast.success(content, options);
  } else if (type === "info") {
    toast.info(content, options);
  } else if (type === "error") {
    toast.error(content, options);
  }
};

const toastContainer = (
  <ToastContainer
    key="toast-container"
    position="top-right"
    newestOnTop={false}
    closeOnClick
    theme="colored"
    hideProgressBar={true}
    icon={true}
    closeButton
  />
);

const UseAlert = () => [toastContainer, showAlert];

export default UseAlert;
